module.exports = __webpack_public_path__ + "static/img/zhuijiao.fefc2e4f.png";